module.exports = __webpack_public_path__ + "img/vue-01-08.8e97f6ed.png";